import axios from "axios";
import { keys } from "src/utils/keys";

// constants
import { BASE_URL } from "src/utils/constants";

export const getPlaceDetail = (_placeId) => {
  const response = axios({
    method: "get",
    url: `https://maps.googleapis.com/maps/api/place/details/json?key=${keys.google_api_key}&place_id=${_placeId}`,
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET",
    },
  });

  return response;
};

export const createEvent = (_data) => {
  console.log(_data);
  let formData = new FormData();

  formData.append("filepath", _data.eventFile?.object);
  formData.append("accessToken", _data.accessToken);
  formData.append("userID", _data.userId);
  formData.append("eventName", _data.eventName);
  formData.append("location", _data.eventLocation?.name);
  formData.append("startDate", _data.eventStartDate);
  formData.append("endDate", _data.eventEndDate);
  formData.append("startTime", _data.eventStartTime);
  formData.append("endTime", _data.eventEndTime);
  formData.append("eventDescription", _data.eventDescription);
  formData.append("latitude", _data.eventLocation?.lat);
  formData.append("longitude", _data.eventLocation?.lng);
  formData.append("dealtext", "123");
  formData.append("percentage", 0);
  formData.append("categoryID", _data.eventCategory?.id);

  const response = axios({
    method: "post",
    url: `${BASE_URL()}/CreateEvent`,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response;
};

export const getUserEvents = (_data) => {
  const response = axios({
    method: "post",
    url: `${BASE_URL()}/MyEvent`,
    data: _data,
  });

  return response;
};
